__turbopack_context__.v({
  "alternativePrice": "comparison-pricing-panel-module__1p1cvG__alternativePrice",
  "amount": "comparison-pricing-panel-module__1p1cvG__amount",
  "companyAmount": "comparison-pricing-panel-module__1p1cvG__companyAmount",
  "range": "comparison-pricing-panel-module__1p1cvG__range",
});
